import React, { useState } from 'react'
import { FaSmile } from 'react-icons/fa'

const QUICK_REACTIONS = ['❤️', '👍', '👎', '😂', '😮', '😢', '😡', '🎉', '🔥', '💯']

const EmojiPicker = ({ isOpen, onToggle, onEmojiSelect, onClose }) => {
  const [customEmoji, setCustomEmoji] = useState('')

  const handleCustomEmojiSubmit = () => {
    if (customEmoji.trim()) {
      onEmojiSelect(customEmoji.trim())
      setCustomEmoji('')
    }
  }

  const handleClose = () => {
    setCustomEmoji('')
    onClose()
  }

  return (
    <div className="relative">
      <button
        onClick={onToggle}
        className="text-gray-400 hover:text-gray-300 transition-colors p-1"
        title="Add reaction"
      >
        <FaSmile className="text-sm" />
      </button>

      {isOpen && (
        <div
          className="fixed bg-black/90 backdrop-blur-sm rounded-xl p-4 border border-white/20 shadow-2xl z-50"
          style={{
            right: '20px',
            bottom: '100px',
            minWidth: '250px'
          }}
        >
          <EmojiPickerHeader />
          <QuickReactions onSelect={onEmojiSelect} />
          <CustomEmojiInput
            value={customEmoji}
            onChange={setCustomEmoji}
            onSubmit={handleCustomEmojiSubmit}
          />
          <EmojiTips />
          <CancelButton onClick={handleClose} />
        </div>
      )}
    </div>
  )
}

const EmojiPickerHeader = () => (
  <div className="text-white font-medium text-sm mb-3">Choose a reaction:</div>
)

const QuickReactions = ({ onSelect }) => (
  <div className="grid grid-cols-5 gap-2 mb-3">
    {QUICK_REACTIONS.map(emoji => (
      <button
        key={emoji}
        onClick={() => onSelect(emoji)}
        className="p-2 rounded-lg hover:bg-white/10 transition-colors text-xl hover:scale-110 transform duration-200"
        title={`React with ${emoji}`}
      >
        {emoji}
      </button>
    ))}
  </div>
)

const CustomEmojiInput = ({ value, onChange, onSubmit }) => (
  <div className="border-t border-white/20 pt-3">
    <div className="text-gray-200 text-sm mb-2 font-medium">Or use any emoji:</div>
    <div className="flex gap-2">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Type or paste emoji..."
        className="emoji-input-field flex-1 px-3 py-2 text-lg bg-white/10 border border-white/20 rounded focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent text-white placeholder-gray-400"
        maxLength={10}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onSubmit()
          }
        }}
      />
      <button
        onClick={onSubmit}
        disabled={!value.trim()}
        className="px-4 py-2 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 text-white text-sm rounded transition-colors font-medium"
      >
        Add
      </button>
    </div>
  </div>
)

const EmojiTips = () => {
  const getTipText = () => {
    const userAgent = navigator.userAgent
    if (userAgent.includes('Mac')) {
      return 'Tip: Press Cmd + Ctrl + Space for native emoji picker'
    } else if (userAgent.includes('Windows')) {
      return 'Tip: Press Windows + . (period) for native emoji picker'
    } else {
      return 'Tip: Use your system\'s emoji picker or mobile keyboard'
    }
  }

  return (
    <div className="text-gray-400 text-xs mt-2">
      {getTipText()}
    </div>
  )
}

const CancelButton = ({ onClick }) => (
  <div className="mt-3 pt-2 border-t border-white/20">
    <button
      onClick={onClick}
      className="w-full text-center text-gray-400 text-xs hover:text-gray-300 transition-colors"
    >
      Cancel
    </button>
  </div>
)

export default EmojiPicker